import { ChipsideComponent } from "../chipside-component";

export class InfoGroupValue extends ChipsideComponent {
	static observedAttributes = ["variation", "multiline", "prevent-scroll", "value"];

	constructor() {
		super();

		this.label = this.getAttribute("label") ?? "";
		this.variation = this.getAttribute("variation");
		this.multiline = this.hasAttribute("multiline");
		this.editable = this.hasAttribute("editable");
		this.maxHeight = this.getAttribute("max-height") ?? "";
		this.default = this.getAttribute("default") ?? "&nbsp;";

		if (this.querySelector("chip-dropdown")) {
			this.preventScroll = true;
		}
	}

	parsedCallback() {
		this.classList.add("information-column");

		this.appendChild(document.createElementWithContents("div", this.innerHTML.trim() !== "" ? this.childNodes : this.default,
			{
				className: `information__value${this.multiline ? " smart-wrap" : ""} ${this.innerHTML.trim() === "" ? "information__value--empty" : ""}`.trim()
			}));

		if (this.label || this.editable) {
			const labelDiv = document.createElementWithContents("div", this.label, { className: "information__description" });

			if (this.editable) {
				const editButton = document.createElementWithContents("button", '<i class="fas fa-pencil"></i>', {
					type: "button",
					className: "btn-body btn--icon btn--sm information__edit",
					onclick: () => this.raiseEvent("editclicked")
				});

				editButton.setAttribute("tooltip", "Edit");
				labelDiv.appendChild(editButton);
			}

			this.prepend(labelDiv);
		}
	}

	attributeChanged(name, _, newValue) {
		if (name === "value") {
			const element = this.querySelector(".information__value");
			element.innerHTML = newValue?.trim() ?? this.default;

			element.toggleClass("information__value--empty", !newValue?.trim());
		}
	}
}